import React from 'react';
import ErpDocPage from '../components/ErpDocPage';
import ErpTablePage from '../components/ErpTablePage';
const VendorBills = () => {
  return <ErpDocPage moduleKey="vendor_bills" />;
};

export default VendorBills;